import { render, staticRenderFns } from "./myProject.vue?vue&type=template&id=18f0b321&scoped=true"
import script from "./myProject.vue?vue&type=script&lang=js"
export * from "./myProject.vue?vue&type=script&lang=js"
import style0 from "./myProject.vue?vue&type=style&index=0&id=18f0b321&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f0b321",
  null
  
)

export default component.exports